export default __webpack_public_path__ + "locales/ro/CreateEditRoomDialog.json?hash=69a18bd54cedb084e55c6e00db357494";